import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CursorGlow from "./CursorGlow";
import WhatsAppFab from "./WhatsAppFab";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return (
    <div className="min-h-screen bg-white text-slate-900 flex flex-col relative overflow-x-hidden">
      <CursorGlow />
      <Navbar />
      <main className="flex-1 pt-20 relative z-10">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
